import { render, staticRenderFns } from "./Reassign-Schedule.vue?vue&type=template&id=50c83134"
import script from "./Reassign-Schedule.vue?vue&type=script&lang=js"
export * from "./Reassign-Schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports